module.exports = __webpack_public_path__ + "img/16581270_L.9b83b6cc.png";